import React, { useState, useRef, useEffect } from 'react';
import './MessageInput.css';

const MessageInput = ({ onSendMessage, disabled }) => {
  const [inputValue, setInputValue] = useState('');
  const textareaRef = useRef(null);

  // Auto-resize textarea
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, 150)}px`;
    }
  }, [inputValue]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputValue.trim() && !disabled) {
      onSendMessage(inputValue);
      setInputValue('');
    }
  };

  const handleKeyPress = (e) => {
    // Send on Enter (without Shift)
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  // Suggested prompts
  const suggestedPrompts = [
    "Summarize this legal document",
    "What are the key clauses?",
    "Check for RERA compliance",
    "Identify potential risks"
  ];

  const handleSuggestedPrompt = (prompt) => {
    setInputValue(prompt);
    textareaRef.current?.focus();
  };

  return (
    <div className="message-input-container">
      {/* Suggested prompts (show only when input is empty) */}
      {inputValue === '' && (
        <div className="suggested-prompts">
          <span className="prompts-label">Try asking:</span>
          {suggestedPrompts.map((prompt, index) => (
            <button
              key={index}
              className="prompt-chip"
              onClick={() => handleSuggestedPrompt(prompt)}
              disabled={disabled}
            >
              {prompt}
            </button>
          ))}
        </div>
      )}

      {/* Input form */}
      <form onSubmit={handleSubmit} className="message-input-form">
        <textarea
          ref={textareaRef}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Ask a question about your legal documents..."
          disabled={disabled}
          className="message-textarea"
          rows="1"
        />
        
        <button 
          type="submit" 
          className="send-button"
          disabled={disabled || !inputValue.trim()}
          title="Send message (Enter)"
        >
          <span className="send-icon">➤</span>
        </button>
      </form>

      {/* Input hints */}
      <div className="input-hints">
        <span className="hint">Press <kbd>Enter</kbd> to send, <kbd>Shift + Enter</kbd> for new line</span>
      </div>
    </div>
  );
};

export default MessageInput;
